import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import {
    useCookieWatcher,
    useCookie,
} from '@fcannizzaro/react-use-cookie-watcher';
import { useDispatch, useSelector } from 'react-redux';
import { COOKIE1, COOKIE2 } from '~/src//config/constants';
import Dialog from './Dialog';
import actionsApp from '~/redux/app/actions';
import actionsCommon from '~/redux/common/actions';
import { DateTime } from 'luxon';

const date = Date.now();

window.domLoadedDate = date;

function App(props) {
    /*
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(true);
    }, []);


    if(loaded) {
        return false;
    }
    console.log(12345);
    return false;
    */

    const qrcode = useSelector((state) => state.app.qrcode);
    const business = useSelector((state) => state.business);
    const menuType = useSelector((state) => state.common.menuType);
    const isNotExpired2 = useCookieWatcher(COOKIE2, {
        // check for changes every 4000ms
        checkEvery: 4000,
    });
    const isNotExpired1 = useCookieWatcher(COOKIE1, {
        // check for changes every 4000ms
        checkEvery: 4000,
    });

    const dispatch = useDispatch();

    //console.log(12345);
    //console.log('COOKIE WATCHER');
    //console.log(menuType);
    //console.log(99999);
    //console.log(isNotExpired1);
    //console.log(isNotExpired2);

    if (menuType === 'inside' && business && business.qrcodes) {
        /*
        if (!isNotExpired1 && !isNotExpired2) {
            const diff = date.diffNow(['seconds']).toObject();
            console.log(diff);

            if(diff.seconds < -60) {
                console.log('RESET CART FROM src/components/CookieWatcher/index.jsx');
                //dispatch(actionsCommon.resetCart());
            } 
        }
        */

        //return false;

        const diff = Date.now() - window.domLoadedDate;

        if (diff > 10000) {
            if (!isNotExpired1 && isNotExpired2) {
                console.log(
                    'REMOVE QRCODE2  FROM src/components/CookieWatcher/index.jsx',
                );
                Cookies.remove(COOKIE2);
            }

            if (!isNotExpired1 && !isNotExpired2 && qrcode !== false) {
                console.log(
                    'RESET QRCODE INFO FROM src/components/CookieWatcher/index.jsx',
                );
                dispatch(actionsApp.setQrcodeInfo(false));
            }

            if (isNotExpired1 && !isNotExpired2) {
                const qrcode1 = Cookies.get(COOKIE1);
                const qrcode2 = Cookies.get(COOKIE2);
                if (typeof qrcode1 === 'string') {
                    const matchQrcode = business.qrcodes.find(
                        (q) => q.code === qrcode1,
                    );

                    if (matchQrcode) {
                        //console.log(98765432);
                        //console.log(isNotExpired1);
                        //console.log(isNotExpired2);
                        //console.log(qrcode1);
                        //console.log(qrcode2);
                        //console.log(window.domLoadedDate);

                        //console.log(matchQrcode);
                        console.log(
                            'DISPLAY DIALOG COOKIE  FROM src/components/CookieWatcher/index.jsx',
                        );
                        return <Dialog title={matchQrcode.name} />;
                    }

                    return false;
                }
            }
        }
    }

    return false;
}

export default App;
